"use client";

import { useState, useCallback } from "react";
import { MatchService } from "../services/matchService";

export function useMatches() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const safeCall = async (apiFn) => {
    setLoading(true);
    setError(null);
    try {
      const res = await apiFn();
      if (!res?.success) {
        setError(res);
      }
      return res;
    } catch (err) {
      setError(err);
      return null;
    } finally {
      setLoading(false);
    }
  };

  // const getMatches = useCallback((params = {}) => {
  //   return safeCall(() => matchesApi.getMatches(params));
  // }, []);

  // const getMatchById = useCallback((id) => {
  //   if (!id) return;
  //   return safeCall(() => matchesApi.getMatchById(id));
  // }, []);

  const getMatchOdds = useCallback((matchId, params = {}) => {
    if (!matchId) return;
    return safeCall(() => MatchService.getMatchOdds(matchId, params));
  }, []);

  // const getMatchAnalysis = useCallback((matchId) => {
  //   if (!matchId) return;
  //   return safeCall(() => matchesApi.getMatchAnalysis(matchId));
  // }, []);

  return {
    loading,
    error,

    // getMatches,
    // getMatchById,
    getMatchOdds,
    // getMatchAnalysis,
  };
}